import { connect } from "react-redux";
import get from "lodash/get";

import { getExceptions as onGetExceptions, deleteExceptions as onDeleteExceptions } from "./../../actions/exceptionsActions";

const mapStateToProps = (state) => ({
  exceptionsDataState: state.exceptions.exceptionsDataState,
  exceptionsDeleteDataState: state.exceptions.exceptionsDeleteDataState,
  exceptions: get(state, ["exceptions", "exceptions"], null),
});

const mapDispatchToProps = { onGetExceptions, onDeleteExceptions };

const withExceptions = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withExceptions };
